var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUdidSuccessIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 322,
    viewBox: "0 0 560 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_5879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 231.526C29 286.089 73.5051 331.77 129.454 331.77H413.015C477.865 331.77 530 279.744 530 215.03C530 152.853 481.68 102.097 419.373 98.2898C377.411 20.8861 282.043 -7.03 204.477 33.5752C166.33 53.8778 138.355 89.4074 126.911 131.282C72.2335 133.819 29 178.231 29 231.526Z",
    fill: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.201 90.1551H202.581C182.187 90.1551 165.655 106.687 165.655 127.081V469.828C165.655 490.222 182.187 506.754 202.581 506.754H353.201C373.594 506.754 390.126 490.222 390.126 469.828V127.081C390.126 106.687 373.594 90.1551 353.201 90.1551Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.673 97.1542H204.106C187.403 97.1542 173.861 110.695 173.861 127.399V467.698C173.861 484.402 187.403 497.943 204.106 497.943H351.673C368.377 497.943 381.919 484.402 381.919 467.698V127.399C381.919 110.695 368.377 97.1542 351.673 97.1542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.537 108.675C272.233 106.978 272.233 104.227 270.537 102.531C268.84 100.834 266.089 100.834 264.392 102.531C262.696 104.227 262.696 106.978 264.392 108.675C266.089 110.371 268.84 110.371 270.537 108.675Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.317 109.948H282.408C280.019 109.948 278.063 107.992 278.063 105.603C278.063 103.214 280.019 101.259 282.408 101.259H288.317C290.706 101.259 292.662 103.214 292.662 105.603C292.662 107.992 290.706 109.948 288.317 109.948Z",
    fill: "#131313"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.734,
    y: 187.734,
    width: 328.533,
    height: 98.1554,
    rx: 13.7332,
    fill: "#F2F4F7",
    stroke: "#DDE1EE",
    strokeWidth: 1.46722
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 255,
    width: 76,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 255,
    width: 193,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 232,
    width: 76,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 209,
    width: 76,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 232,
    width: 193,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 209,
    width: 193,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 129,
    width: 65,
    height: 9,
    rx: 4.5,
    fill: "#A4AABE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.661,
    y: 75.6607,
    width: 72.6798,
    height: 72.6822,
    rx: 36.3399,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.963 97.027C440.305 96.2159 441.734 95.6014 443.207 95.1826L444.08 90.9818L451.177 90.8574L452.199 95.0237C453.686 95.3904 455.135 95.9544 456.505 96.7182L460.092 94.3666L465.198 99.2967L462.975 102.963C463.786 104.305 464.401 105.734 464.819 107.208L469.019 108.083L469.144 115.179L464.977 116.2C464.61 117.687 464.046 119.136 463.283 120.506L465.634 124.093L460.705 129.2L457.038 126.977C455.696 127.788 454.267 128.402 452.794 128.821L451.919 133.022L444.823 133.146L443.802 128.979C442.314 128.612 440.865 128.048 439.496 127.285L435.91 129.635L430.803 124.705L433.026 121.039C432.215 119.697 431.601 118.269 431.182 116.795L426.982 115.92L426.857 108.824L431.025 107.803C431.391 106.316 431.956 104.866 432.718 103.497L430.367 99.9097L435.298 94.8031L438.963 97.027ZM442.746 106.48C439.825 109.506 439.91 114.326 442.935 117.247C445.961 120.168 450.781 120.083 453.701 117.058C456.622 114.032 456.537 109.212 453.512 106.291C450.487 103.371 445.667 103.456 442.746 106.48Z",
    fill: "#1A1D40"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.661,
    y: 75.6607,
    width: 72.6798,
    height: 72.6822,
    rx: 36.3399,
    stroke: "#A4AABE",
    strokeWidth: 1.32145
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_5879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 322,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdidSuccessIllustration);
export default __webpack_public_path__ + "static/media/udid-success-illustration.64b5708a.svg";
export { ForwardRef as ReactComponent };